import React from 'react';
import classnames from 'classnames';
import loading from './loading.svg';

import './Loading.css';

const Loading = ({ className, overlay, size }) => {
  return (
    <div
      className={classnames(
        'Loading',
        { [className]: className },
        { overlay },
        { [size]: size }
      )}
    >
      <img src={loading} alt="loading..." />
    </div>
  );
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js